import * as React from 'react';
import { Props } from './props';

export class OperationItemRowBase extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  shouldComponentUpdate(nextProps: Props): boolean {
    if (nextProps.language !== this.props.language) {
      return true;
    } else if (nextProps.isActive !== this.props.isActive) {
      return true;
    } else {
      return !(JSON.stringify(nextProps.operationItem) === JSON.stringify(this.props.operationItem));
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/row/base-row.tsx